import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup as MuiRadioGroup } from '@mui/material'
import React, { useState } from 'react'
import Alert from '@mui/material/Alert';
import { ProcessedClaimsDialog } from './ProcessedClaimsDialog';
import { useStatePtr } from '@pure-ptr/react';
import { RadioGroup, RadioGroupOption } from '../../../common';

export default function ProcessClaimDialog({ openPtr, intl, claimPageRecord, selectedItemsPtr, claimsData, filter, claimprocessError, significanceFlag, showLowConfidenceClaims=false,
    claimProcessPending, claimBulkProcessPending, handleProcessClaimCallback, claimBulkOnDemandPending,processOnlySelected=false,tableFiltersPtr=undefined,
    actions: { claimAnalysisProcess, claimAnalysisBulkProcess, processBulkOnDemand } }) {

    const [processClaimCallbackDialog, setProcessClaimCallbackDialog] = useState(false);

    const processAllPtr = useStatePtr(false);

    const openProcessedClaimsDialogPtr = useStatePtr(false)
        .onChange( x => {
            if( !x ) {
                openPtr.set(false);
            }
        });

    const handleProcessClaimCallbackDialogClose = () => {
        setProcessClaimCallbackDialog(false);
    }

    const handleProcessClaimSuccessCallback = () => {
        openPtr.set(false);
        selectedItemsPtr.set([]);
        setProcessClaimCallbackDialog(true);
        handleProcessClaimCallback();
    }

    const handleBulkOndemandCallback = () => {
        selectedItemsPtr.set([]);
        handleProcessClaimCallback();
        openProcessedClaimsDialogPtr.set(true);
    }

    const handleErrorCallback = () => {
        openPtr.set(false);
    }

    const selectedItems = selectedItemsPtr.value;

    const handleProcessClaimConfirmation = () => {
        if (selectedItems.length > 0) {
            // Temporary disable process all...
            if ( processAllPtr.value && selectedItems.length > 5) {
               
                let operandsWithoutBoth = (filter?.operands || [])?.filter(obj => 
                    !obj.filters.some(filter => filter.value === "both")
                );
                
                operandsWithoutBoth={operator:filter?.operator,operands:operandsWithoutBoth}
                const payload = {
                    filter:operandsWithoutBoth,
                    showLowConfidenceClaims: showLowConfidenceClaims
                }
                
                claimAnalysisBulkProcess(payload, significanceFlag, handleProcessClaimSuccessCallback, handleErrorCallback);

            } else {
                const claims = claimsData.filter(claim => selectedItems.some(y => (y == claim.id || y == claim.claimnumber)));
                const payload = {
                    claimMetadata: claims.map((claim) => {
                        return {
                            claimNumber: claim.claimnumber,
                            contractId: claim.contractid,
                        }
                    }),
                };
                
                if (claims.length <= 5) {
                    processBulkOnDemand(payload, handleBulkOndemandCallback, handleErrorCallback)
                } else {
                    claimAnalysisProcess(payload, handleProcessClaimSuccessCallback, handleErrorCallback);
                }
            }
        }
    }

    return (
        (<div>
            <Dialog open={openPtr.value}>
                <DialogTitle>
                    {selectedItems?.length === 1 ? 'Process Claim' : 'Process Claims'}
                </DialogTitle>
                <DialogContent>
                    
                        {selectedItems?.length > 0 ? (
                            (claimsData.length === selectedItems.length && !processOnlySelected) ? <>
                                <RadioGroup 
                                    valuePtr={processAllPtr} 
                                    label="Are you sure you want to process"
                                >
                                    <RadioGroupOption value={false}>
                                        {claimsData.length} selected claims
                                    </RadioGroupOption>
                                    <RadioGroupOption value={true}>
                                        All {claimPageRecord.totalRecords } claims
                                    </RadioGroupOption>
                                </RadioGroup>
                            </> : <>
                                <DialogContentText>
                                    {selectedItems.length === 1 
                                        ? 'Are you sure you want to process this claim?' 
                                        : `Are you sure you want to process ${selectedItems.length} claims?`}
                                </DialogContentText>
                            </>
                        ) :
                            'No claims selected, please select atleast one claim to process'
                        }
                    
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => openPtr.set( false ) }>
                        {selectedItems?.length > 0 ? 'Cancel' : 'Close'}
                    </Button>
                    {selectedItems?.length > 0 && (
                        <Button
                            onClick={handleProcessClaimConfirmation}
                            disabled={claimProcessPending || claimBulkProcessPending || claimBulkOnDemandPending}
                            color="primary"
                            variant='contained'
                        >
                            {(claimProcessPending || claimBulkProcessPending || claimBulkOnDemandPending) ? 'Processing...' : (selectedItems?.length === 1 ? 'Process Claim' : 'Process Claims')}
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
            <Dialog open={processClaimCallbackDialog} onClose={handleProcessClaimCallbackDialogClose}>
                <DialogTitle>
                    {selectedItems?.length === 1 ? 'Process Claim' : 'Process Claims'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Alert severity="success">The request is submitted and progress can be monitored on execution logs page.</Alert>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleProcessClaimCallbackDialogClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <ProcessedClaimsDialog openPtr={openProcessedClaimsDialogPtr}/>
        </div>)
    );
}

